import React from "react";
import "./Footer.css";
import history from "../../config/history";
import { connect } from "react-redux";
import { openSignUpModal } from "../../actions/generalActions";

class Footer extends React.Component {
  render() {
    return (
      <div className="footer-container-custom footer">
        <div className="footer-custom container-fluid">
          {/* <h1 className='display-3 coming-soon-custom'>More Treats Coming Soon!</h1>
                    <p className='lead follow-custom'> follow us on <i className='fa fa-instagram' /> <i className='fa fa-facebook' /> <i className='fa fa-twitter' /> </p> */}
          <div className="footer-content-container row">
            <div
              className={`footer-brandname col-md-${
                this.props.userStatus?.isLoggedIn &&
                this.props.userStatus?.isPremium
                  ? 6
                  : !this.props.userStatus?.isPremium
                  ? 3
                  : 4
              } col-12`}
            >
              <div className="footer-brandname-logo">
                <img
                  onClick={() => history.push("/")}
                  className="footer-brandname-logo-img"
                  src={`${process.env.REACT_APP_AWS_IMG_CDN}/logos/Main_logo_350_146.webp`}
                  width="350"
                  height="146"
                  alt="Colourful Logo with the colours red, yellow, orange, peach, purple, blue and brown. The Logo reads “MeenduToons” and has small ice cream scoops and waffles decorated over it"
                />
              </div>
              <div className="footer-brandname-socials">
                <p className="lead follow-custom">
                  {" "}
                  follow us on <br></br>
                  <a href="https://www.instagram.com/meendutoons/">
                    {" "}
                    <i className="fa fa-instagram" />
                  </a>{" "}
                  <a href="https://www.facebook.com/meendutoons">
                    <i className="fa fa-facebook" />
                  </a>{" "}
                  <a href="https://www.youtube.com/channel/UCcTicMHn9Y_XgfbrgRHVNAA">
                    <i className="fa fa-youtube" />
                  </a>{" "}
                </p>
              </div>
            </div>
            <div
              className={`col-md-${
                this.props.userStatus?.isLoggedIn &&
                this.props.userStatus?.isPremium
                  ? 6
                  : !this.props.userStatus?.isPremium
                  ? 4
                  : 5
              } col-12`}
            >
              <div className="footer-nav-links">
                <div className="footer-nav-support-links">
                  <div className="footer-nav-link-heading">Support</div>
                  <a className="footer-nav-links-text" href="/terms">
                    Terms and Conditions
                  </a>
                  <a className="footer-nav-links-text" href="/privacy">
                    Privacy Policy
                  </a>
                  <a className="footer-nav-links-text" href="/contactus">
                    Contact Us
                  </a>
                  <a className="footer-nav-links-text">Site Map</a>
                </div>
                <div className="footer-nav-page-links">
                  <div className="footer-nav-link-heading">MeenduToons</div>
                  <a className="footer-nav-links-text" href="/videos">
                    Videos
                  </a>
                  <a className="footer-nav-links-text" href="/activities">
                    Activities
                  </a>
                  <a className="footer-nav-links-text" href="/characters">
                    Characters
                  </a>
                  {!this.props.userStatus?.isPremium && (
                    <a className="footer-nav-links-text" href="/pricing">
                      Pricing
                    </a>
                  )}
                  {this.props.userStatus?.isLoggedIn && (
                    <a className="footer-nav-links-text" href="/aboutus">
                      About Us
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div
              className={`footer-login-sub col-md-${
                this.props.userStatus?.isLoggedIn &&
                this.props.userStatus?.ispremium
                  ? 0
                  : !this.props.userStatus?.isPremium
                  ? 4
                  : 3
              } col-12`}
            >
              {!this.props.userStatus?.isLoggedIn && (
                <div className="footer-login">
                  <button
                    onClick={() => this.props.openSignUpModal()}
                    className="btn btn-sm btn-primary"
                  >
                    Login
                  </button>
                  <p>to experience sample videos and stories</p>
                </div>
              )}
              {!this.props.userStatus?.isPremium && (
                <div className="footer-sub">
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => history.push("/pricing")}
                  >
                    Subscribe
                  </button>
                  <p>to get access to more exclusive content</p>
                </div>
              )}
            </div>
            <div className="footer-copyright-container col-12">
              <div className="text-center">
                Need help? Contact us at{" "}
                <a href="mailto:info@meendutoons.com">info@meendutoons.com</a>
              </div>
              <div className="footer-copyright-text">
                ©️ 2025. All rights reserved to MeenduToons. All content as
                displayed on this platform are the copyrights of author/owner of
                this website, wherein, no third party shall use any of such
                content without prior written consent of the owner.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};
export default connect(mapStateToProps, { openSignUpModal })(Footer);
